var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { splitClassList } from '../../helpers/classMap.js';
let ElementButton = class ElementButton extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'primary';
        this.disabled = false;
        this.loading = false;
    }
    updated(changedProps) {
        if (changedProps.has('disabled'))
            this.style.pointerEvents = this.disabled ? 'none' : 'all';
    }
    render() {
        const primary = this.type === 'primary';
        const secondaryLight = this.type === 'secondaryLight';
        const secondaryLightB2B = this.type === 'secondaryLightB2B';
        return html ` <button
      type="button"
      class="body-links-and-text ${classMap(splitClassList({
            disabled: this.disabled,
            'bg-primary-gray': this.disabled,
            'text-white': primary || this.disabled,
            'bg-chm-red': primary && !this.disabled,
            'hover:bg-chm-focus-red': (primary || secondaryLightB2B) && !this.disabled,
            'text-chm-red': !primary && !this.disabled && (secondaryLight || secondaryLightB2B),
            'bg-white': !primary && !this.disabled && (secondaryLight || secondaryLightB2B),
            'hover:bg-page-main': !primary && !this.disabled && secondaryLight,
            'hover:text-chm-focus-red': !primary && !this.disabled,
            'group hover:text-white transition-colors duration-300': secondaryLightB2B && !this.disabled,
            'focus:bg-layers-popup': !primary && !this.disabled && secondaryLight,
            'focus:text-chm-focus-red': !primary && !this.disabled && secondaryLight,
            'bg-chm-light-gray': !primary && !secondaryLight,
            'text-chm-gray': !primary && !secondaryLight,
        }))} flex h-logo-s select-none items-center rounded-lg px-[16px] py-[12px] font-bold active:bg-black active:!text-white md:h-logo-m md:px-[24px] md:py-[17px]"
    >
      ${this.loading
            ? html ` <div
              class="${classMap({
                'bg-loader-animated': !primary,
                'bg-loader-animated-white': primary,
            })} mb-[45px] mt-auto h-[24px] w-[24px] self-center bg-no-repeat md:mb-[76px] mdxx:mb-[80px]"
            ></div>` : this.label()}
    </button>`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String })
], ElementButton.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], ElementButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], ElementButton.prototype, "loading", void 0);
__decorate([
    property({ type: Object })
], ElementButton.prototype, "label", void 0);
ElementButton = __decorate([
    customElement('element-button')
], ElementButton);
export { ElementButton };
//# sourceMappingURL=element-button.js.map